<template>
    <dx-cell v-bind="$attrs" v-on="$listeners" :class="this.$attrs.column.className ? this.$attrs.column.className($attrs.tableRow.row) : ''">
      <span  :title="this.$attrs.column.tooltipTitle ? this.$attrs.column.tooltipTitle($attrs.tableRow.row) : ''">
        {{ this.$attrs.column.format ? this.$attrs.column.format(value, $attrs.tableRow.row) : (value && value.value) ? value.value : value  }}
      </span>
    </dx-cell>
</template>

<script>
  import { DxTable } from "@devexpress/dx-vue-grid-bootstrap4";

  export default {
    inheritAttrs: false,
    props: ["value"],
    components: {
      DxCell: DxTable.components.DxCell,
      DxTable
    }
  };
</script>

